export const APP_CONSTANTS = {
  LOGIN: '/',
  USERS: '/users',
  CREATE_USER: '/user/create',
  EDIT_USER: '/user/edit/:id',
  CREATE_PERMISSION_USER: '/user/permission/:id',

  STORE: '/store',
  CREATE_STORE: '/store/create',
  EDIT_STORE: '/store/edit/:id',

  MENU: '/menu/store/:id',

  VOUCHER: '/voucher',
  CREATE_VOUCHER: '/voucher/create',
  EDIT_VOUCHER: '/voucher/edit/:id',
  CREATE_PACKAGE: '/voucher/package/create',
  EDIT_PACKAGE: '/voucher/package/edit/:id',

  CANCEL_VOUCHER: '/cancel-voucher',

  OFFER_DEALS: '/offer-deals',
  CREATE_OFFER_DEALS: '/offer-deals/create',
  EDIT_OFFER_DEALS: '/offer-deals/edit/:id',

  TIER: '/tier',
  CREATE_DEFAULT_TIER: '/default-tier/create',
  EDIT_DEFAULT_TIER: '/default-tier/edit/:id',

  FESTIVE_TIER: '/festive-tier',
  CREATE_FESTIVE_TIER: '/festive-tier/create',
  EDIT_FESTIVE_TIER: '/festive-tier/edit/:id',

  BILL_VALIDATION: '/bill-validation',
  CREATE_BILL_VALIDATION: '/bill-validation/create',
  EDIT_BILL_VALIDATION: '/bill-validation/edit/:id',

  CUSTOMER_MANAGEMENT: '/customers',
  DETAILS_CUSTOMER_MANAGEMENT: '/customers/details/:id',
  COLLECTION_PANEL: '/collection-panel',

  GAMIFICATION_CAMPAIGNS: '/gamification',
  GAMIFICATION_CAMPAIGN_DETAIL: '/gamification/detail/:id',
  GAMIFICATION_CREATE_CAMPAIGN: '/gamification/create',

  ANALYTICS: '/analytics',
  CREATE_ANALYTICS: '/analytics/create',
  EDIT_ANALYTICS: '/analytics/edit/:id',

  MALL: '/mall',
  CREATE_MALL: '/mall/create',
  EDIT_MALL: '/mall/edit/:id',

  MALL_BANNER: '/mall-banner',
  CREATE_MALL_BANNER: '/mall-banner/create',
  EDIT_MALL_BANNER: '/mall-banner/edit/:id',
  BANNER_ANALYTICS: '/mall-banner/analytics/:id',

  MALL_BRAND_BANNER: '/mall-brand-banner',
  CREATE_MALL_BRAND_BANNER: '/mall-brand-banner/create',
  EDIT_MALL_BRAND_BANNER: '/mall-brand-banner/edit/:id',

  SUPPORT_SERVICE: '/mall-support-service',
  CREATE_SUPPORT_SERVICE: '/mall-support-service/create',
  EDIT_SUPPORT_SERVICE: '/mall-support-service/edit/:id',

  EVENT: '/event',
  CREATE_EVENT: '/event/create',
  EDIT_EVENT: '/event/edit/:id',

  GAME_MANAGEMENT: '/games',
  CREATE_GAME: '/games/create',
  EDIT_GAME: '/games/edit/:id',
  GAME_LEADERBOARD: '/games/leaderboard/:id',

  NOTIFICATION: '/notification',
  CREATE_NOTIFICATION: '/notification/create',
  EDIT_NOTIFICATION: '/notification/edit/:id',

  REPORTS: '/reports',

  FEEDBACK_MANAGEMENT: '/feedback-management',
  CREATE_FEEDBACK: '/feedback-management/create',
  EDIT_FEEDBACK: '/feedback-management/edit/:id',

  // Quick task 260922-mmg: Force App Update admin page.
  APP_SETTINGS: '/app-settings',

  MALL_TAG: 'MALL',
  MALL_BANNER_TAG: 'MALL BANNER',
  MALL_BRAND_BANNER_TAG: 'MALL BRAND BANNER',

  CREATE_SUPPORT_SERVICE_TAG: 'Add Service',
  SUPPORT_SERVICE_TAG: 'Mall Eminities',

  REWARDS_TAG: 'REWARDS',
  VOUCHER_TAG: 'VOUCHER',
  PACKAGE_TAG: 'PACKAGE',
  CANCEL_VOUCHER_TAG: 'CANCEL VOUCHER',
  CLEAR_ALL: 'Clear All',

  STORE_TAG: 'STORE',
  EVENT_TAG: 'EVENT',
  OFFER_DEALS_TAG: 'OFFER',
  USERS_TAG: 'USER',

  GAME_MANAGEMENT_TAG: 'GAME',

  BILL_VALIDATION_TAG: 'BILL VALIDATION',
  CUSTOMER_MANAGEMENT_TAG: 'CUSTOMER MANAGEMENT',
  GAMIFICATION_TAG: 'GAMIFICATION',
  ANALYTICS_TAG: 'ANALYTICS',
  TIER_TAG: 'TIER',
  NOTIFICATION_TAG: 'Notification',

  CREATE_FESTIVE_TIER_TAG: 'Add Festive',
  CREATE_DEFAULT_TIER_TAG: 'Add Default',
  CREATE_MALL_TAG: 'Add Mall',
  CREATE_MALL_BANNER_TAG: 'Add Banner',
  CREATE_EVENT_TAG: 'Add Event',
  CREATE_GAME_TAG: 'Add Game',
  CREATE_STORE_TAG: 'Add Store',
  CREATE_USER_TAG: 'Add User',
  CREATE_VOUCHER_TAG: 'Add Voucher',
  CREATE_PACKAGE_TAG: 'Add Bundle',
  CREATE_OFFER_TAG: 'Add Offer',
  CREATE_BILL_VALIDATION_TAG: 'Add Bill',
  CREATE_NOTIFICATION_TAG: 'Add Notification',
  FEEDBACK_MANAGEMENT_TAG: 'FEEDBACK MANAGEMENT',
  APP_SETTINGS_TAG: 'APP SETTINGS',

  DOWNLOAD_EXCEL: 'Download Excel',
  DOWNLOAD_PDF: 'Download PDF',
  DOWNLOAD_CSV: 'Download CSV',
  REPORTS_TAG: 'Reports',

  BASE: 'default',
  ADD0N: 'festive',

  Tier_Management_Key: 'Tier_Management',
  User_Management_Key: 'User_Management',
  Store_Management_Key: 'Store_Management',
  Event_Management_Key: 'Event_Management',
  Bill_Validation_Key: 'Bill_Validation',
  Analytics_and_Reporting_Key: 'Analytics_and_Reporting',
  Mall_Information_Management_Key: 'Mall_Information_Management',
  Customer_Management_Key: 'Customer_Management',
  Notification_Panel_Key: 'Notification_Panel',
  Voucher_or_Rewards_Management_Key: 'Voucher_or_Rewards_Management',
  Cancel_voucher_key: 'Cancel_Voucher',
  Deals_Offers_Management_Key: 'Deals_Offers_Management',
  Feedback_Management_Key: 'Feedback_Management',
  Support_Service_Key: 'SupportDetail',
  Mall_Banner_Key: 'Mall_Banner_Key',
  Games_Management_Key: 'Games_Management',
  // Game Campaigns has its own permission module (backend migration
  // 1786900000000). It used to reuse Voucher_or_Rewards_Management_Key, so
  // voucher permission decided campaign access. Must match the module row's
  // name exactly — the sidebar compares these keys with the module names the
  // permission API returns.
  Gamification_Campaigns_Key: 'Gamification_Campaigns',
  // App Settings has its own permission module (backend migration
  // 1787000000004). Must match the module row's name exactly — the sidebar
  // compares these keys with the module names the permission API returns.
  App_Settings_Key: 'App_Settings',
  Profile: '/profile',
  PROFILE: 'PROFILE',

  SAVE: 'Save',
};
export const ALL_SIDEBAR_COMPONENT_ACCESS_KEYS = [
  APP_CONSTANTS.User_Management_Key,
  APP_CONSTANTS.Mall_Information_Management_Key,
  APP_CONSTANTS.Voucher_or_Rewards_Management_Key,
  APP_CONSTANTS.Cancel_voucher_key,
  APP_CONSTANTS.Store_Management_Key,
  APP_CONSTANTS.Event_Management_Key,
  APP_CONSTANTS.Tier_Management_Key,
  APP_CONSTANTS.Deals_Offers_Management_Key,
  APP_CONSTANTS.Bill_Validation_Key,
  APP_CONSTANTS.Customer_Management_Key,
  APP_CONSTANTS.Analytics_and_Reporting_Key,
  APP_CONSTANTS.Notification_Panel_Key,
  APP_CONSTANTS.Feedback_Management_Key,
  APP_CONSTANTS.Support_Service_Key,
  APP_CONSTANTS.Mall_Banner_Key,
  APP_CONSTANTS.Games_Management_Key,
  APP_CONSTANTS.Gamification_Campaigns_Key,
  // Quick task 260922-mmg: must be the LAST key, or superadmins never see
  // App Settings (Sidebar/index.js uses this list for su; the sidebar
  // renders in array order, D-07).
  APP_CONSTANTS.App_Settings_Key,
];

export const FILE_TYPES_CONSTANTS = {
  VIDEO: 'video',
  IMAGE: 'image',
  IMAGE_JPEG: 'image/jpeg',
  AUDIO: 'audio',
};

export const TOAST_TYPE_CONSTANTS = {
  SUCCESS: 'success',
  ERROR: 'error',
  PRIVATE: 'private',
  RESTRICTED: 'restricted',
  OPEN: 'open',
};

export const USER_ROLE_CONSTANTS = {
  ADMIN: 'ADMIN',
  MEMBER: 'MEMBER',
  SUPER_ADMIN: 'SUPER_ADMIN',
};

export const PROFILE_TYPE_CONSTANTS = {
  PROFILE: 'PROFILE',
};

export const LocalSessionKey = {
  ACCESS_TOKEN: 'accessToken',
  REFRESH_TOKEN: 'refreshToken',
  FINGERPRINT: 'fingerprint',
  FEED_ID: 'feedId',
  BREATEFREE_ID: 'breathefreeId',
  PERMISSSION_TAG: 'permissiontag',
  VERSION: 'ver',
  USER_INFO: 'userInfo',
  ROLE: 'role',
  MODULE_LIST: 'moduleList',
  MALL_LIST: 'mallList',
  MALL_ID: 'mallId',
  CUSTOMER_DATA: 'customerData',
  CAMPAIGN_DATA: 'campaignData',
};

export const EventType = {
  EDIT: 'EDIT',
  DELETE: 'DELETE',
  PUBLISH_UNPUBLISH: 'PUBLISH_UNPUBLISH',
};

export const URLType = {
  EXTERNAL: 'EXTERNAL',
  EXTERNAL_PWA: 'EXTERNAL_PWA',
  INTERNAL: 'INTERNAL',
  INTERNAL_PWA: 'INTERNAL_PWA',
  YES: 'YES',
  NO: 'NO',
  MCQ: 'mcq',
  CHECKBOX: 'checkbox',
  QUIZ_CHECKBOX: 'option_box',
  FILL: 'fill',
  DATE_TIME: 'dob',
  attachmentFile: 'attachmentFile',
  webinar_record_link: 'webinar_record_link',
};

export const Format = {
  DateTime: 'YYYY-MM-DD HH:mm:ss',
};

export const RegexValidations = {
  EMAIL: /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/i,
};
